import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

import { CloseButton } from './close-button';
import { DialogModel } from './confirm-dialog';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import ImageBoxFuture from './image-box-future';
import { pxToRem } from '@/theme/typography';

export const InfoDialog: FC<DialogModel> = ({
  buttonId,
  img,
  title,
  description,
  handleOkayClick,
}) => {
  const theme = useTheme();

  return (
    <>
      <DialogTitle>
        <CloseButton handleClick={handleOkayClick} />
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            alignItems: 'center',
            margin: 'auto',
          }}
        >
          <Box sx={{ marginBlock: 4 }}>
            <ImageBoxFuture
              img={img}
              title={title}
              objectFit='contain'
              sx={{
                width: '108px',
                height: '102px',
              }}
            />
          </Box>
          <Typography
            sx={{
              color: theme.palette.grey[90],
              fontSize: pxToRem(22),
              fontWeight: 700,
              lineHeight: '33px',
              marginBottom: pxToRem(24),
            }}
          >
            <FormattedMessage id={title} />
          </Typography>
          <Typography
            sx={{
              color: theme.palette.grey[70],
              fontSize: pxToRem(18),
              fontWeight: 400,
              lineHeight: '27px',
              textAlign: 'center',
            }}
          >
            <FormattedMessage id={description} />
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          id={`${buttonId}-okay`}
          variant='contained'
          fullWidth
          onClick={handleOkayClick}
          sx={{ height: { tablet: pxToRem(56), mobile: '56px' } }}
        >
          <FormattedMessage id='global.okay' />
        </Button>
      </DialogActions>
    </>
  );
};
